import { render, staticRenderFns } from "./contract_suspend_use.vue?vue&type=template&id=764a43e3"
import script from "./contract_suspend_use.vue?vue&type=script&lang=js"
export * from "./contract_suspend_use.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports